import { render, staticRenderFns } from "./RecipientsUpload.vue?vue&type=template&id=4178f975&scoped=true&"
import script from "./RecipientsUpload.vue?vue&type=script&lang=js&"
export * from "./RecipientsUpload.vue?vue&type=script&lang=js&"
import style0 from "./RecipientsUpload.vue?vue&type=style&index=0&id=4178f975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4178f975",
  null
  
)

export default component.exports